// ABOUTME: Helpers for saving unresolved scope candidates returned by scope search.
// ABOUTME: Combined create payloads and derives inherited form baselines for pending scopes.

import { LEVEL_TO_API } from '../types'
import type { PendingScopeRequest } from '../context/EntityFormContext'

interface ConfigWithParentValues<TValues> {
    id?: string
    parentValues: TValues
    _meta?: object
}

export const getConfigScopeId = (
    scopeId: string | undefined,
    pendingScope: PendingScopeRequest | undefined,
    rootScopeId: string | undefined,
): string | undefined => scopeId ?? (pendingScope ? pendingScope.parentId : rootScopeId)

export const toPendingScopeConfig = <TValues, TConfig extends ConfigWithParentValues<TValues>>(
    config: TConfig | undefined,
    pendingScope: PendingScopeRequest | undefined,
    getValues: (config: TConfig) => TValues,
): TConfig | undefined => {
    if (!config || !pendingScope) return config

    return {
        ...config,
        id: undefined,
        parentValues: getValues(config),
        ...(config._meta ? { _meta: { ...config._meta, isInherited: true } } : {}),
    }
}

export const toCreateScopeAndConfigRequest = <TConfiguration>(
    scope: PendingScopeRequest,
    configuration: TConfiguration,
) => ({
    scope: {
        countryId: scope.countryId,
        businessLine: scope.businessLine,
        level: LEVEL_TO_API[scope.level],
        identifiers: scope.identifiers,
    },
    configuration,
})
